module.exports = __webpack_public_path__ + "img/fits-into-all.0a7fdb9c.svg";